// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"lY-z","subtitle":"mY-z","wrapper":"nY-z","leftArrow":"oY-z","rightArrow":"pY-z"};